const getFieldsConfig = () =>
  fetch(`${process.env.PUBLIC_URL}/config/fields.json`).then(res => res.json());

const getFormConfig = () =>
  fetch(`${process.env.PUBLIC_URL}/config/formconfig.json`).then(res => res.json());

export default {
  getFieldsConfig,
  getFormConfig
};
